import { createContext } from 'react'

export const CashierUserContext = createContext()
